import { z } from "zod";
import {
  ControlDataTypeKey,
  Types,
  Schema
} from "../prop-controllers";
import { P, match } from "ts-pattern";
const tableFormFieldSchema = z.object({
  id: z.string(),
  tableColumnId: z.string(),
  label: z.string().optional(),
  placeholder: z.string().optional(),
  defaultValue: z.union([z.string(), z.boolean(), z.array(z.string())]).optional(),
  required: z.boolean().optional(),
  hidden: z.boolean().optional(),
  type: z.union([z.literal("select"), z.literal("radio")]).optional(),
  hideLabel: z.boolean().optional(),
  autofill: z.boolean().optional()
});
const tableFormFieldsDataSchema = z.object({
  fields: z.array(tableFormFieldSchema),
  grid: Schema.responsiveValue(
    z.object({
      count: z.number(),
      spans: z.array(z.array(z.number()))
    })
  )
});
const tableFormFieldsPropControllerDataV0Schema = tableFormFieldsDataSchema;
const TableFormFieldsPropControllerDataV1Type = "prop-controllers::table-form-fields::v1";
const tableFormFieldsPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(TableFormFieldsPropControllerDataV1Type),
  value: tableFormFieldsDataSchema
});
const tableFormFieldsPropControllerDataSchema = z.union([
  tableFormFieldsPropControllerDataV0Schema,
  tableFormFieldsPropControllerDataV1Schema
]);
function TableFormFields(options = {}) {
  return { type: Types.TableFormFields, version: 1, options };
}
function getTableFormFieldsPropControllerDataTableFormFieldsData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: TableFormFieldsPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createTableFormFieldsPropControllerDataFromTableFormFieldsData(value, definition) {
  return match(definition).with(
    { version: 1 },
    P.nullish,
    () => ({
      [ControlDataTypeKey]: TableFormFieldsPropControllerDataV1Type,
      value
    })
  ).otherwise(() => value);
}
function copyTableFormFieldsData(data, context) {
  if (data == null)
    return data;
  return {
    ...data,
    fields: data.fields.map((field) => ({
      ...field,
      tableColumnId: context.replacementContext.tableColumnIds.get(field.tableColumnId) ?? field.tableColumnId
    }))
  };
}
function copyTableFormFieldsPropControllerData(data, context) {
  return match(data).with(void 0, () => void 0).with(
    { [ControlDataTypeKey]: TableFormFieldsPropControllerDataV1Type },
    (v1) => ({
      [ControlDataTypeKey]: TableFormFieldsPropControllerDataV1Type,
      value: copyTableFormFieldsData(v1.value, context)
    })
  ).otherwise((v0) => copyTableFormFieldsData(v0, context));
}
export {
  TableFormFields,
  TableFormFieldsPropControllerDataV1Type,
  copyTableFormFieldsPropControllerData,
  createTableFormFieldsPropControllerDataFromTableFormFieldsData,
  getTableFormFieldsPropControllerDataTableFormFieldsData,
  tableFormFieldsDataSchema,
  tableFormFieldsPropControllerDataSchema
};
//# sourceMappingURL=table-form-fields.js.map